<script setup>
import { defineEmits, reactive, watch } from 'vue'
import { state, params } from '@/components/Ajuda/Montador/composables/useBuilderState'
// import DecimalField from '@/components/Ajuda/Montador/components/Fields/DecimalField.vue'

const emit = defineEmits(['clear-course'])

// Mantém o último valor global conhecido para limpar "falsos overrides"
const lastGlobals = reactive({
  pathTension:     params.path.pathTension,
  curveSmoothness: params.path.curveSmoothness,
  rMin:            params.path.rMin,
})

function approxEq(a, b, eps = 1e-6) {
  return Number.isFinite(a) && Number.isFinite(b) && Math.abs(a - b) <= eps
}

function sweepSegments(kind, oldVal) {
  const segs = state.tools.course || []
  for (const seg of segs) {
    const v = seg?.[kind]
    if (v == null) continue          // já herda; nada a fazer
    if (approxEq(v, oldVal)) {
      delete seg[kind]               // deixa de ser local; volta a herdar o novo global
    }
  }
  lastGlobals[kind] = params.path[kind]
}

// Quando os globais mudam (via sliders do sidebar OU via Modal), varremos os segmentos
watch(() => params.path.pathTension,     (nv, ov) => sweepSegments('pathTension', ov))
watch(() => params.path.curveSmoothness, (nv, ov) => sweepSegments('curveSmoothness', ov))
watch(() => params.path.rMin,            (nv, ov) => sweepSegments('rMin', ov))



function togglePath() {
  state.tools.pathActive = !state.tools.pathActive
}
function clearCourse() {
  emit('clear-course')
}
</script>

<template>
  <!-- Curso / montagem -->
  <div class="section">
    <label class="label">Curso</label>
    <div class="row">
      <button class="btn" @click="togglePath">
        {{ state.tools.pathActive ? 'Sair do modo montar' : 'Entrar no modo montar' }}
      </button>
      <button class="btn" @click="clearCourse">Limpar percurso</button>
    </div>
    <div class="hint">No modo montar, clique (ou Ctrl+clique) nos obstáculos para (des)incluir no percurso.</div>
  </div>

  <!-- Parâmetros globais do curso -->
  <div class="section">
    <label class="label">Percurso (globais)</label>

    <div class="row" style="gap:12px">
      <div style="flex:1">
        <div class="sub">Curvatura</div>
        <input type="range" min="0" max="1" step="0.01"
              v-model.number="params.path.pathTension" />
        <div class="hint">{{ (params.path.pathTension ?? 0).toFixed(2) }}</div>
      </div>

      <div style="flex:1">
        <div class="sub">Suavidade</div>
        <input type="range" min="0" max="1" step="0.01"
              v-model.number="params.path.curveSmoothness" />
        <div class="hint">{{ (params.path.curveSmoothness ?? 0).toFixed(2) }}</div>
      </div>
    </div>

    <div class="row">
      <div style="flex:1">
        <div class="sub">Raio</div>
        <input type="range" min="2" max="20" step="0.1"
              v-model.number="params.path.rMin" />
        <div class="hint">{{ (params.path.rMin ?? 0).toFixed(1) }} m</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.label { margin: 0 0 6px; font-size: 13px; color: #9eb3ff; }
</style>
